import { ChangeEvent, FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  ModalProps,
  Stack,
  TextField,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

import { PaymentMethod } from '../../../../../enums';
import {
  DepositFiatWalletDTO,
  UpdateWalletProviderDTO,
  WithdrawFiatWalletDTO,
} from '../../../../../api';
import { useGetProvidersQuery } from '../../../../../api/controllers/providers';

export type ActionFields = UpdateWalletProviderDTO['body'];

export type ActionModalProps = {
  open: boolean;
  onClose: () => void;
  provider: string;
  onSuccess: (values: ActionFields, resetFields: () => void) => void;
  isLoading: boolean;
};

export const EditProviderModal: FC<ActionModalProps> = (props) => {
  const { open, onClose, onSuccess, isLoading, provider } = props;
  const { t } = useTranslation();
  const { data: poviders } = useGetProvidersQuery({});
  // fields logic
  const [fields, setFields] = useState<ActionFields | undefined>({
    provider: provider,
  });
  console.log(provider);
  console.log(fields);
  const handleFields = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const name = e.target.name as keyof DepositFiatWalletDTO['body'];
    const value = e.target.value;

    // @ts-ignore
    setFields((prevState) => {
      if (!prevState) {
        return {
          [name]: value,
        };
      }

      return {
        ...prevState,
        [name]: value,
      };
    });
  };
  const resetFields = () => {
    setFields(undefined);
  };

  // validation for required fields
  const requiredFields = ['provider'] as (keyof UpdateWalletProviderDTO['body'])[];
  const checkSubmitDisabling = () => {
    if (!fields) return true;

    for (const field of requiredFields) {
      if (fields[field] === undefined || fields[field] === '') {
        return true;
      }
    }
    return false;
  };

  // close handlers
  const closeHandlerWithPrevent: ModalProps['onClose'] = (_, reason) => {
    if (reason === 'backdropClick') return;
    setFields(undefined);
    onClose();
  };
  const closeHandler = () => {
    setFields(undefined);
    onClose();
  };

  // elements
  const providerOptions = poviders?.providers.map((p) => (
    <MenuItem key={p} value={p}>
      {p}
    </MenuItem>
  ));

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => closeHandlerWithPrevent(_, reason)}
      PaperProps={{ sx: { minWidth: '380px' } }}
    >
      <DialogTitle>{t('profile-wallets.actions.edit-provider')}</DialogTitle>
      <IconButton
        aria-label="close"
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
        onClick={() => closeHandler()}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent>
        <Stack direction="column" spacing={2}>
          <TextField
            select
            name="provider"
            value={fields?.provider}
            onChange={(e) => handleFields(e)}
            label={t('profile-wallets.actions.provider')}
            fullWidth
          >
            {providerOptions}
          </TextField>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button
          variant="contained"
          onClick={() => fields && onSuccess(fields, resetFields)}
          disabled={isLoading || checkSubmitDisabling()}
        >
          {t('profile-wallets.actions.btn.update')}
        </Button>
        <Button variant="outlined" onClick={() => closeHandler()} disabled={isLoading}>
          {t('profile-wallets.actions.btn.cancel')}
        </Button>{' '}
      </DialogActions>
    </Dialog>
  );
};
